import { pageApi } from '../../api/page.api';
import { ISubscriberIdMetaResponse, subscriberIdGeneralMapping } from './mapping';
import { ISubscriberIdMeta, ISubscriberIdMetaQuery } from './types';
import { formatSubscriberIdApiUrl } from './utils/formatApiUrl';

export const subscriberIdApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        getSubscriberIdMeta: builder.query<ISubscriberIdMeta, ISubscriberIdMetaQuery>({
            query: ({ subscriberId }) => formatSubscriberIdApiUrl(subscriberId, 'meta'),
            transformResponse: (response: ISubscriberIdMetaResponse, _, arg) =>
                subscriberIdGeneralMapping(response, arg.userType),
        }),
    }),
});

export const {
    useGetSubscriberIdMetaQuery,
} = subscriberIdApi;
